import { render, staticRenderFns } from "./CheckIconSVG.vue?vue&type=template&id=19ced23d"
import script from "./CheckIconSVG.vue?vue&type=script&lang=js"
export * from "./CheckIconSVG.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports